<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
